import { memo, type ReactNode, useContext } from 'react';

import { ComponentSwitchContext } from './contexts/ComponentSwitch.context';

export type ComponentSwitchItemProps = {
  value: string | boolean | number | null;
  children?: ReactNode;
};

export const ComponentSwitchItemBase = ({ value, children = null }: ComponentSwitchItemProps) => {
  const currentValue = useContext(ComponentSwitchContext);

  return currentValue === value
    ? // Need to use JSX to make docgen and eslint detect this as a component.

      children
    : null;
};

ComponentSwitchItemBase.displayName = 'ComponentSwitchItem';

export const ComponentSwitchItem = memo(ComponentSwitchItemBase);
